// extracted by mini-css-extract-plugin
export default {"imgbox":"Banner_imgbox__IYgQV","imageText2":"Banner_imageText2__nkJ6S","content":"Banner_content__Nyjud","text":"Banner_text__DjsXd"};